/**
 * Created by Lenovo on 2017/5/24.
 */
import React, {Component} from 'react'
import {Link} from 'react-router'
import {language, getUserId, resultTip} from 'UTIL/common'
export default class ZtreeInput extends Component {
    onkeyupHandle(){
        var id = this.props.id;
        if(this.props.intNumber){
            var value = $.trim($("#"+id).val());
            if(value.length==1){
                value=value.replace(/[^1-9]/g,'')
            }
            else{
                value=value.replace(/\D/g,'')
            }
            if(value.length>5){
                value = value.substring(0,5)
            }
            $("#" + id).val(value);
        }
    }
    render() {
        return (
            <div className="col-md-offset-1">
                <div className="form-group">
                    <label htmlFor="name"
                           className="col-sm-3 control-label"> {language()[this.props.name]}
                    </label>
                    <div className="col-sm-4 col-md-offset-1">
                            <input type="text" className="form-control" id={this.props.id} onChange={this.onkeyupHandle.bind(this)}
                               name={this.props.id}/>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/form/ztreeInput.js